import { useState, useRef, useEffect } from "react";
import { HeaderBackTitle } from "../common/header";
import _ from "lodash";
import { IconVehicle } from "../common/icon";
import { _postURL } from "@/api/index";
import { VehicleBrandModal, VehicleModelModal } from "../modal";
import { pageLink } from "../../config/site";
import Link from 'next/link';
import Redux from "@/action";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { TextInput, NumberInput, Select } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useRouter } from "next/router";
import { _getAllVehicleBrandList, _getAllVehicleModelList, _getAllTyreSize } from "../../libraries/common";
import { CommonCategory } from '@/components/common/category';
import Picker from 'react-mobile-picker';
import { MyBody } from "../body/body";

const bodyTypeList = [
    {value: 'sedan', label: 'sedan'},
    {value: 'hatchback', label: 'hatchback'},
    {value: 'suv', label: 'suv'},
    {value: 'cabriolet', label: 'cabriolet'},
    {value: 'sport', label: 'sport'},
    {value: 'mpv', label: 'mpv'},
    {value: 'truck', label: 'truck'},
    {value: 'wagon', label: 'wagon'},
    {value: 'pickup', label: 'pickup'}
]
const otherList = [
    {
        category: "size", 
        categoryName: "Size",
        item: [
            {value: '15', label: '15"'},
            {value: '16', label: '16"'},
            {value: '17', label: '17"'},
            {value: '18', label: '18"'},
            {value: '19', label: '19"'},
            {value: '20', label: '20"'},
            {value: '21', label: '21"'},
            {value: '22', label: '22"'},
            {value: '23', label: '23"'},
            {value: '24', label: '24"'},
            {value: '25', label: '25"'},
            {value: '26', label: '26"'},
            {value: '27', label: '27"'}
        ]
    },
    {
        category: "drivingExperience", 
        categoryName: "Driving Experience",
        item: [
            {value: 'ev', label: 'EV'},
            {value: 'comfort', label: 'Comfort'},
            {value: 'suv', label: 'SUV'},
            {value: 'sport', label: 'Sport'},
            {value: 'track_performance', label: 'Track & Performance'},
            {value: 'commercial', label: 'Commercial'}
        ]
    },
]
const SelectedButton = (props) => {
    const { label = "", isActive = false, handleOnClick = ()=>{} } = props
    return (
        <div onClick={handleOnClick} className={isActive == true ? "vehicleFilter_brand_item cursorPointer vehicleFilter_brand_item_active" : "vehicleFilter_brand_item cursorPointer"}>
            <p className={`fontSize_14 ${isActive == true ? "fontWeight_semiBold fontColor_white" : "fontColor_grey4"}`}>
                {label}
            </p>
        </div>
    )
}

const selections = {
    title: ['165', '170', '175', '180'],
    firstName: ['55', '60', '65'],
    lastName: ['14', '15', '16', '17', '18']
}

export const TyreFilter = (props) => {
    const { t, device, session, params, fetchedData } = props
    const { store, dispatch } = Redux();
    const [filter, setFilter] = useState({bodyType: [], size: [], drivingExperience: []})
    const [category, setCategory] = useState(1);
    const [filterLink, setFilterLink] = useState('');
    const router = useRouter()

    // vehicle brand moal
    const [vehicleBrandModalOpen, setVehicleBrandModalOpen] = useState(false)
    const [vehicleBrandImage, setVehicleBrandImage] = useState(null)

    // vehicle model modal
    const [vehicleModelModalOpen, setVehicleModelModalOpen] = useState(false)
    const [vehicleModelData, setVehicleModelData] = useState([]) // model list by brand
    const [vehicleModelLoading, setVehicleModelLoading] = useState(false)

    // tyre detail
    const [allTyreSize, setAllTyreSize] = useState([]);
    const [tyreWidth, setTyreWidth] = useState([])
    const [tyreAspectRatio, setTyreAspectRatio] = useState([])
    const [tyreRimDiameter, setTyreRimDiameter] = useState([])
    
    const [pickerValue, setPickerValue] = useState({tyreWidthSelected: 0, tyreAspectRatioSelected: 0, tyreRimDiameterSelected: 0}) 

    const filterCatergory = [
        {id: 1, text: t("tyre_sizes")},
        {id: 2, text: t("vehicle")},
        {id: 3, text: t("filter")}
    ]

    const { getInputProps, onSubmit, isValid, values, setFieldError, setFieldValue, reset } = useForm({
        initialValues: {
            tyreWidth: 0,
            tyreAspectRatio: 0,
            tyreRimDiameter: 0,
        },
    });

    const _setPickerValue = async(value) => {
        setTyreAspectRatio(_.keys(_.get(allTyreSize, value?.tyreWidthSelected)));
        setTyreRimDiameter(_.get(allTyreSize, value?.tyreWidthSelected)?.[value?.tyreAspectRatioSelected]);

        setPickerValue({ tyreWidthSelected: value?.tyreWidthSelected, tyreAspectRatioSelected: value?.tyreAspectRatioSelected, tyreRimDiameterSelected: value?.tyreRimDiameterSelected });
    }

    const _searchTyreBySpec = async() => {
        const filterLink = '';
        /*
        if(values.tyreWidth > 0 && values.tyreAspectRatio > 0 && values.tyreRimDiameter > 0){
            filterLink += '?search_type=by_spec&';
            if(values.tyreWidth > 0){
                filterLink += 'width='+values.tyreWidth
            }
            if(values.tyreAspectRatio > 0){
                filterLink += '&aspect_ratio='+values.tyreAspectRatio
            }
            if(values.tyreRimDiameter > 0){
                filterLink += '&rim_diameter='+values.tyreRimDiameter
            }
        }
        filterLink.substring(0, filterLink.length - 1);
        
        if(values.tyreWidth > 0 && values.tyreAspectRatio > 0 && values.tyreRimDiameter > 0){
            router.push(pageLink.tyre.filterResult+filterLink);
        }
        */

        if(pickerValue.tyreWidthSelected > 0 && pickerValue.tyreAspectRatioSelected > 0 && pickerValue.tyreRimDiameterSelected > 0){
            filterLink += '?search_type=by_spec&';
            if(pickerValue.tyreWidthSelected > 0){
                filterLink += 'width='+pickerValue.tyreWidthSelected
            }
            if(pickerValue.tyreAspectRatioSelected > 0){
                filterLink += '&aspect_ratio='+pickerValue.tyreAspectRatioSelected
            }
            if(pickerValue.tyreRimDiameterSelected > 0){
                filterLink += '&rim_diameter='+pickerValue.tyreRimDiameterSelected
            }
        }
        filterLink.substring(0, filterLink.length - 1);

        if(pickerValue.tyreWidthSelected > 0 && pickerValue.tyreAspectRatioSelected > 0 && pickerValue.tyreRimDiameterSelected > 0){
            router.push(pageLink.tyre.filterResult+filterLink);
        }
    }

    const _handleOnClick = (value, type) => {
        setFilter((prevFilter)=> {
            let filterData = [...prevFilter[type]]
            if(_.includes(prevFilter[type], value) ){
                // remove value then already inside array
                filterData = _.filter(prevFilter[type], (item) => item != value);
            } else {
                // merge push value in array
                filterData = _.uniq([...prevFilter[type], value])
            }
            let newFilter = { ...prevFilter, [type]: filterData };
            return newFilter;
        })
    }

    const _searchTyreByFilter = () => {
        const filterLink = '';
        if(!_.isEmpty(filter.bodyType) || !_.isEmpty(filter.size) || !_.isEmpty(filter.drivingExperience)){
            filterLink += '?search_type=by_filter&';
        }
        // Body type
        if (!_.isEmpty(filter.bodyType)) {
            let bodyType = _.join(filter.bodyType, ',');
            filterLink += 'body_type='+bodyType+'&';
        }

        // Rim diameter
        if (!_.isEmpty(filter.size)) {
            let size = _.join(filter.size, ',');
            filterLink += 'rim_diameter='+size+'&';
        }

        // Rim diameter
        if (!_.isEmpty(filter.drivingExperience)) {
            let drivingExperience = _.join(filter.drivingExperience, ',');
            filterLink += 'driving_experience='+drivingExperience+'&';
        }
        filterLink = filterLink.substring(0, filterLink.length - 1);
        
        router.push(pageLink.tyre.filterResult+filterLink);      
    }

    const _handleBrandOnClick = async(value) => {
        try {
            //  get all model list under vehicle brand id
            setVehicleModelModalOpen(true)
            setVehicleModelLoading(true)
            setVehicleBrandImage(value?.image_path)
            await _getAllVehicleModelList(setVehicleModelData, {
                vehicleBrandId: value?.vehicle_brand_id
            });
            setVehicleModelLoading(false)
        } catch(error) {
            console.log(error)
        }
    }

    const _handleModelOnClick = async(value) => {
        const filterLink = '?search_type=by_vehicle&';

        // Vehicle model
        if (!_.isEmpty(value.model_custom_url)) {
            filterLink += 'model='+value.model_custom_url+'&';
        }
        filterLink = filterLink.substring(0, filterLink.length - 1);
        
        router.push(pageLink.tyre.filterResult+filterLink);
    }

    const _handleTab = (value) => {
        setCategory(value)
        if(value == 2){
            setVehicleBrandModalOpen(true)
            setCategory(1)
        }
    };

    useEffect(()=>{
        const fetchData = async()=>{
            try{
                if(_.isEmpty(store?.path?.dataAllVehicleBrandList)){
                    await _getAllVehicleBrandList(dispatch);
                }

                // get all available tyre size
                await _getAllTyreSize(setAllTyreSize);

                // set default tyre width
                setTyreWidth(_.keys(allTyreSize));
            } catch(error) {
                console.log(error)
            } finally {

            }
        }
        fetchData()
    },[])

    return (
        <>
            {/* <AllMeta
                title={t('tyreFilterPage_meta_title')}
                description={t('tyreFilterPage_meta_description')}
                keyword={t('tyreFilterPage_meta_keyword')}
            />
            <Head><title>{t('tyreFilterPage_title')}</title></Head> */}
            <MyBody
                t={t}
                showFooter={false}
                headerComponent={
                    <HeaderBackTitle 
                        title={t("tyre_filter")} 
                        showSearch={false}
                        showMenu={false}
                        t={t}
                        subTab={
                            <CommonCategory 
                                data={filterCatergory}
                                activeCategory={category}
                                setActiveCategory={_handleTab}
                                t={t}
                                isAllAllow={false}
                                isFull={true}
                                isSubTab={true}
                            />
                        }
                    />
                }
                isSubTab={true}
                navigationComponent={
                    <div className="vehicleFilter_bottomNavigation tyreFilter_bottomNavigation containerPadding">
                        {
                            category == 1 && 
                            <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreBySpec() } }>
                                <div className="searchTyreBoxButtonInner">
                                    <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
                                </div>
                            </div>
                        }
                        {
                            category == 3 &&
                            <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreByFilter() } }>
                                <div className="searchTyreBoxButtonInner">
                                    <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
                                </div>
                            </div>
                        }
                    </div>
                }
                modalComponent={
                    <>
                        <VehicleBrandModal 
                            t={t}
                            vehicleBrandModalOpen={vehicleBrandModalOpen}
                            setVehicleBrandModalOpen={setVehicleBrandModalOpen}
                            handleClickBrandItem={(value)=>{_handleBrandOnClick(value)}}
                            vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
                            isMultipleModal={false}
                        />
                        <VehicleModelModal 
                            t={t}
                            vehicleModelModalOpen={vehicleModelModalOpen}
                            setVehicleModelModalOpen={setVehicleModelModalOpen}
                            handleClickModelItem={_handleModelOnClick}
                            vehicleModelData={vehicleModelData}
                            vehicleBrandImage={vehicleBrandImage}
                            isMultipleModal={false}
                            loading={vehicleModelLoading}
                        />
                    </>
                }
            >
                <>
                    <div style={{position: 'relative'}}>
                        <div className="vehicleFilter">
                            <div className="containerPadding vehicleFilter_right">
                                
                                {
                                    category == 1 && 
                                    <div className="searchTyreBoxOuter">
                                        {/* <div className="fontSize_16 fontWeight_medium">{t('determine_own_tyre')}</div> */}
                                        <div className="fontSize_16 fontWeight_medium">{t('search_by_size')}</div>
                                        <p className="fontSize_16 fontWeight_semiBold">
                                                {t('tyre_sizes')}
                                            </p>
                                        <img 
                                            className="tyreSizeImage w-100"
                                            src={"/assets/images/how_to_read_tyre.png"}
                                        />
                                        <div className="tyreFilterPickerBox">
                                            <div className="tyreFilterPickerBoxInner">
                                                <Picker value={pickerValue} onChange={_setPickerValue} wheelMode="normal" height={144}>
                                                    <div className="tyreFilterPickerDesc">
                                                        <div className="containerPadding tyreFilterPickerDescInner">
                                                            <p className="tyreFilterPickerDescSeperate">mm /</p>
                                                            <p className="tyreFilterPickerDescSeperate">R</p>
                                                            <p className="tyreFilterPickerDescSeperate">inches</p>
                                                        </div>
                                                    </div>
                                                    <Picker.Column key={'tyreWidthSelected'} name={'tyreWidthSelected'} style={{ zIndex: 2 }}>
                                                        <Picker.Item key={"0"} value={"0"}>
                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
                                                                0
                                                            </p>
                                                        </Picker.Item>
                                                        {
                                                            _.reduce(allTyreSize, (result, value, key)=>{
                                                                result.push(
                                                                    <Picker.Item key={key} value={key}>
                                                                        {({selected}) => (
                                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000': '#D1D1D1' }}>
                                                                                {key}
                                                                            </p>
                                                                        )}
                                                                    </Picker.Item>
                                                                )
                                                                return result
                                                            },[])
                                                        }
                                                    </Picker.Column>
                                                    <Picker.Column key={'tyreAspectRatioSelected'} name={'tyreAspectRatioSelected'} style={{ zIndex: 2 }}>
                                                        <Picker.Item key={"0"} value={"0"}>
                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
                                                                0
                                                            </p>
                                                        </Picker.Item>
                                                        {
                                                            _.reduce(tyreAspectRatio, (result, value, key)=>{
                                                                result.push(
                                                                    <Picker.Item key={key} value={value}>
                                                                        {({selected}) => (
                                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000' : '#D1D1D1' }}>
                                                                                {value}
                                                                            </p>
                                                                        )}
                                                                    </Picker.Item>
                                                                )
                                                                return result
                                                            },[])
                                                        }
                                                    </Picker.Column>
                                                    <Picker.Column key={'tyreRimDiameterSelected'} name={'tyreRimDiameterSelected'} style={{ zIndex: 2 }}>
                                                        <Picker.Item key={"0"} value={"0"}>
                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
                                                                0
                                                            </p>
                                                        </Picker.Item>
                                                        {
                                                            _.reduce(tyreRimDiameter, (result, value, key)=>{
                                                                result.push(
                                                                    <Picker.Item key={key} value={value}>
                                                                        {({selected}) => (
                                                                            <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000' : '#D1D1D1' }}>
                                                                                {value}
                                                                            </p>
                                                                        )}
                                                                    </Picker.Item>
                                                                )
                                                                return result
                                                            },[])
                                                        }
                                                    </Picker.Column>
                                                </Picker>
                                            </div>
                                        </div>

                                        { /*
                                        <div className="searchTyreBox fontSize_14 fontWeight_medium">
                                            <Select
                                                classNames={{
                                                    wrapper: "tyre_width_textInput_wrapper",
                                                    input: "tyre_width_textInput fontSize_14"
                                                }}
                                                rightSection={`mm /`}
                                                rightSectionWidth={`4rem`}
                                                data={tyreWidth}
                                                {...getInputProps('tyreWidth')}
                                                onChange={(value) => {_setTyreAspectRatio(value), setFieldValue("tyreAspectRatio", 0), setFieldValue("tyreRimDiameter", 0)}}
                                            />
                                            <Select
                                                classNames={{
                                                    wrapper: "tyre_asr_textInput_wrapper",
                                                    input: "tyre_asr_textInput fontSize_14"
                                                }}
                                                rightSection={`% R`}
                                                rightSectionWidth={`4rem`}
                                                data={tyreAspectRatio}
                                                {...getInputProps('tyreAspectRatio')}
                                                onChange={(value) => {_setTyreRimDiameter(value), setFieldValue("tyreRimDiameter", 0)}}
                                            />
                                            <Select
                                                classNames={{
                                                    wrapper: "tyre_radius_textInput_wrapper",
                                                    input: "tyre_radius_textInput fontSize_14"
                                                }}
                                                rightSection={`inches`}
                                                rightSectionWidth={`6rem`}
                                                data={tyreRimDiameter}
                                                {...getInputProps('tyreRimDiameter')}
                                            />
                                        </div>
                                        */ }
                                    </div>
                                }
                                {
                                    category == 3 && 
                                    <div className="searchTyreBoxOuter">
                                        <div className="fontSize_16 fontWeight_medium">{t('filter')}</div>
                                        <p className="fontSize_16 fontWeight_semiBold">
                                            {t('body_type')}
                                        </p>
                                        <div className="vehicleFilter_bodyType_content">
                                            {
                                                _.reduce(bodyTypeList, (result, value, key)=>{
                                                    result.push(
                                                        <div 
                                                            onClick={()=>{_handleOnClick(value.value, "bodyType")}} 
                                                            key={key} 
                                                            className="vehicleFilter_bodyType_item cursorPointer"
                                                        >
                                                            <div>
                                                                <IconVehicle
                                                                    color={!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "#E91C21" : undefined}
                                                                    type={value.value}
                                                                />
                                                            </div>
                                                            <p className={ `fontSize_14 ${!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "fontColor_red" : "fontColor_grey4"}` }>
                                                                {value.label}
                                                            </p>
                                                        </div>
                                                    )
                                                    return result
                                                },[])
                                            }
                                        </div>
                                        {
                                            _.reduce(otherList, (result, value, key)=>{
                                                result.push(
                                                    <div key={key} className="vehicleFilter_list">
                                                        <p className="fontSize_16 fontWeight_semiBold">
                                                            {t(value.categoryName)}
                                                        </p>
                                                        <div className="vehicleFilter_list_content" style={{ gridTemplateColumns: `${ value.category == 'size' ? '1fr 1fr 1fr' : '1fr 1fr' }` }}>
                                                            {
                                                                _.reduce(value?.item, (result2, value2, key2)=>{
                                                                    result2.push(
                                                                        <SelectedButton
                                                                            key={`${key}-${key2}`} 
                                                                            label={value2.label}
                                                                            handleOnClick={()=>{_handleOnClick(value2.value, value.category)}}
                                                                            isActive={!_.isEmpty(filter?.[value.category]) ? _.includes(filter?.[value.category], value2.value) : false}
                                                                        />
                                                                    )
                                                                    return result2
                                                                },[])
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                                return result
                                            },[])
                                        }
                                        {/* <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreByFilter() } }>
                                            <div className="searchTyreBoxButtonInner">
                                                <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
                                            </div>
                                        </div> */}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         {/* <AllMeta
    //             title={t('tyreFilterPage_meta_title')}
    //             description={t('tyreFilterPage_meta_description')}
    //             keyword={t('tyreFilterPage_meta_keyword')}
    //         />
    //         <Head><title>{t('tyreFilterPage_title')}</title></Head> */}
    //         <div className='bodyContainer'>
    //             <div className="contentContainer bodyContainerHasBottomNavigation">
    //                 <div className="vehicleFilterHeader">
    //                     <div className="vehicleFilterHeader_inner" style={{ paddingBottom: 'unset' }}>
    //                         <HeaderBackTitle 
    //                             title={t("tyre_filter")} 
    //                             showSearch={false}
    //                             showMenu={false}
    //                             t={t}
    //                         />
    //                     </div>
    //                     <div>
    //                         <CommonCategory 
    //                             data={filterCatergory}
    //                             activeCategory={category}
    //                             setActiveCategory={_handleTab}
    //                             t={t}
    //                             isAllAllow={false}
    //                             isFull={true}
    //                         />
    //                     </div>
    //                 </div>
    //                 <div className="vehicleFilter tyreFilter">
    //                     <div className="containerPadding vehicleFilter_right">
    //                         {
    //                             category == 1 && 
    //                             <div className="searchTyreBoxOuter">
    //                                 {/* <div className="fontSize_16 fontWeight_medium">{t('determine_own_tyre')}</div> */}
    //                                 <div className="fontSize_16 fontWeight_medium">{t('search_by_size')}</div>
    //                                 <p className="fontSize_16 fontWeight_semiBold">
    //                                         {t('tyre_sizes')}
    //                                     </p>
    //                                 <img 
    //                                     className="tyreSizeImage w-100"
    //                                     src={"/assets/images/how_to_read_tyre.png"}
    //                                 />
    //                                 <div className="tyreFilterPickerBox">
    //                                     <div className="tyreFilterPickerBoxInner">
    //                                         <Picker value={pickerValue} onChange={_setPickerValue} wheelMode="normal" height={144}>
    //                                             <div className="tyreFilterPickerDesc">
    //                                                 <div className="containerPadding tyreFilterPickerDescInner">
    //                                                     <p className="tyreFilterPickerDescSeperate">mm /</p>
    //                                                     <p className="tyreFilterPickerDescSeperate">R</p>
    //                                                     <p className="tyreFilterPickerDescSeperate">inches</p>
    //                                                 </div>
    //                                             </div>
    //                                             <Picker.Column key={'tyreWidthSelected'} name={'tyreWidthSelected'} style={{ zIndex: 2 }}>
    //                                                 <Picker.Item key={"0"} value={"0"}>
    //                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
    //                                                         0
    //                                                     </p>
    //                                                 </Picker.Item>
    //                                                 {
    //                                                     _.reduce(allTyreSize, (result, value, key)=>{
    //                                                         result.push(
    //                                                             <Picker.Item key={key} value={key}>
    //                                                                 {({selected}) => (
    //                                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000': '#D1D1D1' }}>
    //                                                                         {key}
    //                                                                     </p>
    //                                                                 )}
    //                                                             </Picker.Item>
    //                                                         )
    //                                                         return result
    //                                                     },[])
    //                                                 }
    //                                             </Picker.Column>
    //                                             <Picker.Column key={'tyreAspectRatioSelected'} name={'tyreAspectRatioSelected'} style={{ zIndex: 2 }}>
    //                                                 <Picker.Item key={"0"} value={"0"}>
    //                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
    //                                                         0
    //                                                     </p>
    //                                                 </Picker.Item>
    //                                                 {
    //                                                     _.reduce(tyreAspectRatio, (result, value, key)=>{
    //                                                         result.push(
    //                                                             <Picker.Item key={key} value={value}>
    //                                                                 {({selected}) => (
    //                                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000' : '#D1D1D1' }}>
    //                                                                         {value}
    //                                                                     </p>
    //                                                                 )}
    //                                                             </Picker.Item>
    //                                                         )
    //                                                         return result
    //                                                     },[])
    //                                                 }
    //                                             </Picker.Column>
    //                                             <Picker.Column key={'tyreRimDiameterSelected'} name={'tyreRimDiameterSelected'} style={{ zIndex: 2 }}>
    //                                                 <Picker.Item key={"0"} value={"0"}>
    //                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: '#D1D1D1' }}>
    //                                                         0
    //                                                     </p>
    //                                                 </Picker.Item>
    //                                                 {
    //                                                     _.reduce(tyreRimDiameter, (result, value, key)=>{
    //                                                         result.push(
    //                                                             <Picker.Item key={key} value={value}>
    //                                                                 {({selected}) => (
    //                                                                     <p className="fontSize_14 tyreFilterPickerItem" style={{ color: selected ? '#000000' : '#D1D1D1' }}>
    //                                                                         {value}
    //                                                                     </p>
    //                                                                 )}
    //                                                             </Picker.Item>
    //                                                         )
    //                                                         return result
    //                                                     },[])
    //                                                 }
    //                                             </Picker.Column>
    //                                         </Picker>
    //                                     </div>
    //                                 </div>

    //                                 { /*
    //                                 <div className="searchTyreBox fontSize_14 fontWeight_medium">
    //                                     <Select
    //                                         classNames={{
    //                                             wrapper: "tyre_width_textInput_wrapper",
    //                                             input: "tyre_width_textInput fontSize_14"
    //                                         }}
    //                                         rightSection={`mm /`}
    //                                         rightSectionWidth={`4rem`}
    //                                         data={tyreWidth}
    //                                         {...getInputProps('tyreWidth')}
    //                                         onChange={(value) => {_setTyreAspectRatio(value), setFieldValue("tyreAspectRatio", 0), setFieldValue("tyreRimDiameter", 0)}}
    //                                     />
    //                                     <Select
    //                                         classNames={{
    //                                             wrapper: "tyre_asr_textInput_wrapper",
    //                                             input: "tyre_asr_textInput fontSize_14"
    //                                         }}
    //                                         rightSection={`% R`}
    //                                         rightSectionWidth={`4rem`}
    //                                         data={tyreAspectRatio}
    //                                         {...getInputProps('tyreAspectRatio')}
    //                                         onChange={(value) => {_setTyreRimDiameter(value), setFieldValue("tyreRimDiameter", 0)}}
    //                                     />
    //                                     <Select
    //                                         classNames={{
    //                                             wrapper: "tyre_radius_textInput_wrapper",
    //                                             input: "tyre_radius_textInput fontSize_14"
    //                                         }}
    //                                         rightSection={`inches`}
    //                                         rightSectionWidth={`6rem`}
    //                                         data={tyreRimDiameter}
    //                                         {...getInputProps('tyreRimDiameter')}
    //                                     />
    //                                 </div>
    //                                 */ }
    //                             </div>
    //                         }
    //                         {
    //                             category == 3 && 
    //                             <div className="searchTyreBoxOuter">
    //                                 <div className="fontSize_16 fontWeight_medium">{t('filter')}</div>
    //                                 <p className="fontSize_16 fontWeight_semiBold">
    //                                     {t('body_type')}
    //                                 </p>
    //                                 <div className="vehicleFilter_bodyType_content">
    //                                     {
    //                                         _.reduce(bodyTypeList, (result, value, key)=>{
    //                                             result.push(
    //                                                 <div 
    //                                                     onClick={()=>{_handleOnClick(value.value, "bodyType")}} 
    //                                                     key={key} 
    //                                                     className="vehicleFilter_bodyType_item cursorPointer"
    //                                                 >
    //                                                     <div>
    //                                                         <IconVehicle
    //                                                             color={!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "#E91C21" : undefined}
    //                                                             type={value.value}
    //                                                         />
    //                                                     </div>
    //                                                     <p className={ `fontSize_14 ${!_.isEmpty(filter?.["bodyType"]) && _.includes(filter?.["bodyType"], value.value) ? "fontColor_red" : "fontColor_grey4"}` }>
    //                                                         {value.label}
    //                                                     </p>
    //                                                 </div>
    //                                             )
    //                                             return result
    //                                         },[])
    //                                     }
    //                                 </div>
    //                                 {
    //                                     _.reduce(otherList, (result, value, key)=>{
    //                                         result.push(
    //                                             <div key={key} className="vehicleFilter_list">
    //                                                 <p className="fontSize_16 fontWeight_semiBold">
    //                                                     {t(value.categoryName)}
    //                                                 </p>
    //                                                 <div className="vehicleFilter_list_content" style={{ gridTemplateColumns: `${ value.category == 'size' ? '1fr 1fr 1fr' : '1fr 1fr' }` }}>
    //                                                     {
    //                                                         _.reduce(value?.item, (result2, value2, key2)=>{
    //                                                             result2.push(
    //                                                                 <SelectedButton
    //                                                                     key={`${key}-${key2}`} 
    //                                                                     label={value2.label}
    //                                                                     handleOnClick={()=>{_handleOnClick(value2.value, value.category)}}
    //                                                                     isActive={!_.isEmpty(filter?.[value.category]) ? _.includes(filter?.[value.category], value2.value) : false}
    //                                                                 />
    //                                                             )
    //                                                             return result2
    //                                                         },[])
    //                                                     }
    //                                                 </div>
    //                                             </div>
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                                 {/* <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreByFilter() } }>
    //                                     <div className="searchTyreBoxButtonInner">
    //                                         <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
    //                                     </div>
    //                                 </div> */}
    //                             </div>
    //                         }
    //                     </div>
    //                 </div>
    //                 <div className="vehicleFilter_bottomNavigation tyreFilter_bottomNavigation containerPadding">
    //                     {
    //                         category == 1 && 
    //                         <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreBySpec() } }>
    //                             <div className="searchTyreBoxButtonInner">
    //                                 <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
    //                             </div>
    //                         </div>
    //                     }
    //                     {
    //                         category == 3 &&
    //                         <div className="searchTyreBoxButtonOuter cursorPointer" onClick={ () => { _searchTyreByFilter() } }>
    //                             <div className="searchTyreBoxButtonInner">
    //                                 <p className="fontSize_16 fontWeight_bold fontColor_white">{t('search_tyre')}</p>
    //                             </div>
    //                         </div>
    //                     }
    //                 </div>
    //             </div>
    //             <VehicleBrandModal 
    //                 t={t}
    //                 vehicleBrandModalOpen={vehicleBrandModalOpen}
    //                 setVehicleBrandModalOpen={setVehicleBrandModalOpen}
    //                 handleClickBrandItem={(value)=>{_handleBrandOnClick(value)}}
    //                 vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
    //                 isMultipleModal={false}
    //             />
    //             <VehicleModelModal 
    //                 t={t}
    //                 vehicleModelModalOpen={vehicleModelModalOpen}
    //                 setVehicleModelModalOpen={setVehicleModelModalOpen}
    //                 handleClickModelItem={_handleModelOnClick}
    //                 vehicleModelData={vehicleModelData}
    //                 vehicleBrandImage={vehicleBrandImage}
    //                 isMultipleModal={false}
    //                 loading={vehicleModelLoading}
    //             />
    //         </div>
    //     </>
    // )
}